import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';

import SEO from 'utils/seo';
import Loader from 'components/atoms/svgLoader';
import ImageProject from 'components/atoms/imageProject';
import { loaderIn, loaderOut, profileIn } from 'components/utils/animation';

import './style.css';

class ProfilePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            animated: false
        };
    }

    componentDidMount() {
        if (this.props.hasLoaded) {
            this.loaderNode.style.display = 'none';
            profileIn(this.bioNode, this.kitlistNode);
            this.setState({
                animated: true
            });
        } else {
            loaderIn(this.loaderNode);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.hasLoaded &&
            !this.props.isLoading &&
            !this.state.animated
        ) {
            loaderOut(this.loaderNode).finished.then(() => {
                profileIn(this.bioNode, this.kitlistNode);
            });

            this.setState({
                animated: true
            });
        }
    }

    render() {
        let {
            body,
            path,
            image,
            phoneNumber,
            emailAddress,
            kitlist,
            hasLoaded
        } = this.props;

        return (
            <div className="ProfilePage">
                <SEO schema="Website" path={path} hasLoaded={hasLoaded} />
                <div
                    className="ProfilePage__loader"
                    ref={div => {
                        this.loaderNode = div;
                    }}
                >
                    <Loader theme="dark" />
                </div>
                <div
                    className="ProfilePage__bio"
                    ref={div => {
                        this.bioNode = div;
                    }}
                >
                    <div className="Bio">
                        <div className="Bio__image">
                            <ImageProject url={image.url} title={image.title} />
                        </div>
                        <div className="Bio__text">
                            <div className="BioText">
                                <ReactMarkdown
                                    className="BioText__body"
                                    source={body}
                                />

                                <div className="BioText__contact">
                                    <div className="BioText__contact__phone">
                                        <div className="BioContact">
                                            <div className="BioContact__type">
                                                Phone
                                            </div>
                                            <div className="BioContact__value">
                                                {phoneNumber}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="BioText__contact__email">
                                        <div className="BioContact">
                                            <div className="BioContact__type">
                                                Email
                                            </div>
                                            <div className="BioContact__value">
                                                {emailAddress}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="ProfilePage__kitlist"
                    ref={div => {
                        this.kitlistNode = div;
                    }}
                >
                    <div className="Kitlist">
                        <div className="Kitlist__title">Kit list</div>
                        <ReactMarkdown
                            className="Kitlist__body"
                            source={kitlist}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

ProfilePage.defaultProps = {
    // body: 'LEMON'
};

export default ProfilePage;



// WEBPACK FOOTER //
// ./src/components/templates/profile/index.js